import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark-grey text-white py-8">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <img
              src="/logo-gold.png"
              alt="DayShift Sports MMA"
              className="h-10 w-auto"
            />
          </div>
          <p className="text-white/60 text-sm">
            The ultimate fantasy MMA platform for UFC fans worldwide.
          </p>
          <div className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} DayShift Sports. All rights
            reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
